export default "https://cdn.questicon.mathletics.com/assets/images/swipe-icon-72bba4682f7888c181823aa7cb5fa85a.svg";